import BriskCreateCertificate from "../BriskCreateCertificate/BriskCreateCertificate";
import BriskCreateCertificateV2 from "./BriskCreateCertificateV2";
import BriskCertificateList from "../BriskCertificateList/BriskCertificateList";
import BriskAgencyWallet from "../BriskWallet/BriskAgencyWallet";
import BriskWalletHistory from "../BriskWallet/BriskWalletHistory";
import BriskTransactionReport from "../BriskWallet/BriskTransactionReport";
import {
  isBriskV2Enabled,
  BRISK_V2_LIST_PATH,
  BRISK_V2_WALLET_PATH,
  BRISK_V2_HISTORY_PATH,
  BRISK_V2_REPORT_PATH,
} from "../../../Shared/briskV2Flag";

/**
 * Which page /briskCreateCertificate shows: the new Brisk API page when REACT_APP_BRISK_V2_ENABLED is "true",
 * otherwise today's page, unchanged (it stays in the code as the "switch off" page).
 */
export const pickBriskCreatePage = (enabled = isBriskV2Enabled()) => (enabled ? BriskCreateCertificateV2 : BriskCreateCertificate);

/** The new pages' entries for the Dashboard's path map — none at all while the switch is off. */
export const briskV2ListPages = (enabled = isBriskV2Enabled()) =>
  enabled
    ? {
        [BRISK_V2_LIST_PATH]: BriskCertificateList,
        [BRISK_V2_WALLET_PATH]: BriskAgencyWallet,
        [BRISK_V2_HISTORY_PATH]: BriskWalletHistory,
        [BRISK_V2_REPORT_PATH]: BriskTransactionReport,
      }
    : {};
